module.exports = __webpack_public_path__ + "oktaVerify@2x.8146a7091eda20534f86ceadfb34a1fa.png";